import { render, staticRenderFns } from "./premium-fukidashi.vue?vue&type=template&id=c9c8d074&scoped=true"
import script from "./premium-fukidashi.vue?vue&type=script&lang=js"
export * from "./premium-fukidashi.vue?vue&type=script&lang=js"
import style0 from "./premium-fukidashi.vue?vue&type=style&index=0&id=c9c8d074&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9c8d074",
  null
  
)

export default component.exports